var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PublicNav'),_c('div',{staticClass:"min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }